import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'

import DatePicker from "react-datepicker"
import Select from "react-select"
import { Modal } from 'react-bootstrap'

import { GET, httpOk, POST } from 'helpers/api';
import { formatDate, formatMoney, returnMinDate } from 'helpers/helpers';
import { useSelector } from 'react-redux';

function PaymentModal({ modalExpense, toggleModal, searchWithFilter, counterparty, counterparty_id }) {
    const { t } = useTranslation();
    const date = new Date();

    const reduxAccount = useSelector(state => state.account)

    const [selectedItem, setSelectedItem] = useState({
        'payment_purpose_id': '',
        'amount': '',
        'note': '',
        'created_at': formatDate(date, 'yyyy-MM-dd'),
    });

    const [counterparties, setCounterparties] = useState([])
    const [paymentTypes, setPaymentTypes] = useState([])
    const [paymentPurposeTypes, setPaymentPurposeTypes] = useState([])
    const [accounts, setAccounts] = useState([])

    async function createExpense(e) {
        e.preventDefault();

        var response = await POST('/expense-web', selectedItem, { loader: true })

        if (httpOk(response)) {
            toggleModal(false)
            setSelectedItem({
                'payment_purpose_id': 6,
                'amount': '',
                'note': '',
                'created_at': formatDate(date, 'yyyy-MM-dd'),
            })
            searchWithFilter()
        }
    }

    async function handleSelectPPT(option) {
        setSelectedItem({
            ...selectedItem,
            'payment_purpose_id': option.id,
            'transaction_type': option.transaction_type,
            'account_chef_id': option.account_chef_id,
            'account_core_id': option.account_core_id,
            'counterparty': option.counterparty ?? null,
            'counterparty_id': counterparty_id ? counterparty_id : null,
        })

        if (option.counterparty) getCounterparty(option)
        if (!option.counterparty) setCounterparties([])
    }

    async function selectAccount(option) {
        setSelectedItem({
            ...selectedItem,
            'account_core_id': option?.id,
            'is_usd': option?.is_usd,
            'payment_type_id': option?.payment_types[0]?.id,
        });
        setPaymentTypes(option?.payment_types)
    }

    async function getCounterparty(option) {
        var response = await POST('/helper/counterparties-type', {
            'payment_purpose_id': option.id
        }, { loader: true })

        if (httpOk(response)) setCounterparties(response.data)
    }

    async function getPaymentPurposeTypes() {
        const response = await GET('/helper/ppt-expense', { counterparty: counterparty })
        if (httpOk(response)) setPaymentPurposeTypes(response.data)
    }

    async function getAccounts() {
        const response = await GET('/helper/accounts')
        if (httpOk(response)) setAccounts(response.data)
    }

    useEffect(() => {
        getAccounts()
        getPaymentPurposeTypes()
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    return (
        <Modal show={modalExpense} animation={false}
            centered dialogClassName="update-modal-width"
            backdrop="static" onHide={() => toggleModal(false)}>
            <Modal.Header closeButton>
                <Modal.Title>{t('expense')}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <form onSubmit={createExpense} autoComplete="off">
                    <div className="form-group">
                        <label>{t('date')}</label>
                        <div className="calendar-input">
                            <DatePicker
                                className="form-control"
                                dateFormat="dd.MM.yyyy"
                                selected={selectedItem.created_at ? new Date(selectedItem.created_at) : ''}
                                onChange={(date) => setSelectedItem({ ...selectedItem, 'created_at': formatDate(date, 'yyyy-MM-dd') })}
                                minDate={returnMinDate(new Date(), reduxAccount.backdate ?? 3)}
                                maxDate={new Date()}
                            />
                            <i className="uil uil-calendar-alt"></i>
                        </div>
                    </div>
                    <div className="form-group">
                        <label>{t('expense_type')}<span className="required-mark">*</span></label>
                        <Select
                            isDisabled={selectedItem.update}
                            options={paymentPurposeTypes}
                            value={paymentPurposeTypes.find(option => option.id === selectedItem.payment_purpose_id)}
                            onChange={(option) => handleSelectPPT(option)}
                            placeholder=""
                            noOptionsMessage={() => t('list_empty')}
                            getOptionLabel={(option) => `${option.name} [${option.transaction_type === 'minus' ? t('expense') : t('income')}]`}
                            getOptionValue={(option) => option.id}
                        />
                    </div>
                    <div className="form-group">
                        <label>{t('counterparty')}<span className="required-mark">*</span></label>
                        <Select
                            isDisabled={!(selectedItem.counterparty)}
                            options={counterparties}
                            value={counterparties.find(option => option.id && option.id === selectedItem.counterparty_id) || null}
                            onChange={(option) => setSelectedItem({ ...selectedItem, 'counterparty_id': option ? option.id : null })}
                            placeholder=""
                            noOptionsMessage={() => t('list_empty')}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                        />
                    </div>
                    <div className="form-group">
                        <label>{t('report_account')}</label>
                        <Select
                            options={accounts}
                            value={accounts.find(option => option.id === selectedItem.account_core_id)}
                            onChange={(option) => selectAccount(option)}
                            placeholder=""
                            noOptionsMessage={() => t('list_empty')}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                        />
                    </div>
                    <div className="form-group">
                        <label>{t('payment_type')}</label>
                        <Select
                            options={paymentTypes}
                            value={paymentTypes.find(option => option.id === selectedItem.payment_type_id)}
                            onChange={(option) => setSelectedItem({ ...selectedItem, 'payment_type_id': option?.id, })}
                            placeholder=""
                            noOptionsMessage={() => t('list_empty')}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.id}
                            isDisabled={paymentTypes.length === 0}
                        />
                    </div>
                    <div className="form-group">
                        <label>{t('amount')}<span className="required-mark">*</span></label>
                        <input type="text" className="form-control" name="amount"
                            value={selectedItem.amount ? formatMoney(selectedItem.amount) : ''}
                            onChange={(e) => setSelectedItem({ ...selectedItem, 'amount': e.target.value.replace(/[^0-9.]/g, '') })} />
                    </div>
                    <div className="form-group">
                        <label>{t('note')}</label>
                        <input type="text" className="form-control" name="note"
                            value={selectedItem.note ?? ''}
                            onChange={(e) => setSelectedItem({ ...selectedItem, 'note': e.target.value })} />
                    </div>
                    <div className="d-flex w-100 mt-3 gap-2">
                        <button type="button" className="btn btn-outline-warning w-100"
                            onClick={() => toggleModal(false)} tabIndex="-1">
                            {t('cancel')}
                        </button>
                        {selectedItem.id ?
                            <button type="submit" className="btn btn-primary w-100"
                                disabled={!selectedItem.amount}>
                                {t('save')}
                            </button>
                            :
                            <button type="submit" className="btn btn-primary w-100">
                                {t('save')}
                            </button>
                        }
                    </div>
                </form>
            </Modal.Body>
        </Modal>
    )
}

export default PaymentModal